import React, { ReactElement } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, RouteProps } from 'react-router-dom';
import { Breed } from '../../../structures/models/breed';
import { SearchContainer } from './search';

interface BreedSearchProps extends RouteProps {
  breed: Breed;
  listingType: string;
}

const BreedSearch: React.FC<BreedSearchProps> = (data): ReactElement => {
  const {
    breed,
    listingType,
    ...rest
  } = data;
  return (
    <div className="py-3 search-container">
      <SearchContainer
        listingsType={listingType}
        breedSlug={breed.name}
        syncURL={true}
        {...rest}
      />
    </div>
  );
};

export default BreedSearch;

if (document.getElementsByClassName('react-breed-search').length > 0) {
  const element = document.getElementsByClassName('react-breed-search')[0];
  const breed = JSON.parse(element.getAttribute('data-breed') ?? '');
  const listingType = element.getAttribute('data-listingType') ?? '';
  ReactDOM.render(
    <BrowserRouter>
      <Route
        path="/"
        render={(routeProps) => (
          <BreedSearch
            breed={breed}
            listingType={listingType}
            {...routeProps}
          />
        )}
      />
    </BrowserRouter>,
    document.getElementById('search-component'),
  );
}
